import * as React from 'react';
import { Numberbox } from 'ui';
import { ScreenField, ScreenFieldProps } from 'app/area/codetable/item/screen-renderer/types';
import { ReadOnlyType } from 'app/area/codetable/item/types';

export const MinLevel = ({ codeItem, updateByKey, resetValidation, translation, readOnlyConfig, validation }: ScreenFieldProps) => {
  
  const onChange = (value: number) => {
    resetValidation(ScreenField.minLevel);
    updateByKey(ScreenField.minLevel, value);
  };

  const minLevelValidation = !!validation && !!validation.minLevel ? validation.minLevel : undefined;

  return <div className="col-lg-6 col-sm-12">
    <Numberbox
      componentId="code_min_level"
      readOnly={readOnlyConfig && readOnlyConfig[ReadOnlyType.all]}
      label={translation ? { text: translation.min_level } : undefined}
      value={codeItem && codeItem.minLevel}
      onChange={onChange}
      useThousand=" "
      maxValue={999999999}
      validation={minLevelValidation}
      textInvalidRangeError={translation.must_be_within_range}
    />
  </div>;
};
